import methods from '@/enums/methods'
import ThothV2 from '../base/thothV2'

class BlacklistService extends ThothV2 {
  
  getAll() {
    return this.fetch({
      url: 'blacklist-companies/',
      method: methods.GET,
    })
  }

  save({ type, document, name, reason, source,username }) {
    return this.fetch({
      url: 'blacklist-companies/save',
      method: methods.POST,
      data: {
        type,
        document,
        name,
        reason,
        source,
        username
      },
    })
  }

  saveByFile(file, username) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('username', username) 

    return this.fetch({
      url: 'blacklist-companies/save-by-file',
      method: methods.POST,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  inactivate({ document, reason, username }) {
    return this.fetch({
      url: 'blacklist-companies/inactivate',
      method: methods.POST,
      data: {
        document,
        reason,
        username
      },
    })
  }

  getByFilter(filter) {
    return this.fetch({
      url: 'blacklist-companies/filter',
      method: methods.GET,
      params: {
        filter
      }
    })
  }

  getReasons() {
    return this.fetch({
      url: 'blacklist-companies/reasons',
      method: methods.GET,
    })
  }

  getTemplateUrl() {
    return this.fetch({
      url: 'blacklist-companies/file-template',
      method: methods.GET,
    })
  }
}

export default new BlacklistService()